export const underscoreCapitalize = (text) => {
  if (!text) return ""; // Handle empty or undefined input

  return text
    .split("_") // Split the string by underscores
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
    .join(" "); // Join the words with spaces
};
